/*  Copyright (c) 2020 Bankers Healthcare Group All rights reserved  */
import axios from 'axios';

export const StatusCodes = {
  SUCCESS: 200,
  SUCCESS202: 202,
  SUCCESS204: 204,
  ENDSUCCESS: 300,
  UNAUTHORIZED: 401,
};

export const appApi = axios.create({
  baseURL: process.env.VUE_APP_API_DOMAIN,
  validateStatus: status => (status >= StatusCodes.SUCCESS && status < StatusCodes.ENDSUCCESS) || status === StatusCodes.UNAUTHORIZED,
});

appApi.defaults.headers = {
  'Cache-Control': 'no-cache',
  'Pragma': 'no-cache',
  'Expires': '0',
};
